import { useCallback } from 'react';

import { useAnalytics } from './use-analytics';

/**
 * Returns a callback which fires an editionAwareness dialog closed event
 */
export const useOnCloseDialog = () => {
	const { sendAnalyticsEvent } = useAnalytics();

	return useCallback(
		(attributes?: Record<string, unknown>) => {
			sendAnalyticsEvent({
				action: 'closed',
				actionSubject: 'dialog',
				actionSubjectId: 'editionAwarenessDialog',
				attributes,
			});
		},
		[sendAnalyticsEvent],
	);
};
